import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'lib-rx-form-option-card',
  templateUrl: './rx-form-option-card.component.html',
  styleUrls: ['./rx-form-option-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RxFormOptionCardComponent {
  readonly icon = input.required<string>();
  readonly title = input.required<string>();
  readonly description = input.required<string>();

  readonly selected = output<void>();

  public activate(): void {
    this.selected.emit();
  }

  public onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }

    event.preventDefault();
    this.activate();
  }
}
